export default "__VITE_ASSET__CJRBrmOU__"